import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
import Box from '@classify/react-core-components/Box';
import Button from '@classify/react-core-components/Button';
import { ROUTES } from '@openclassrooms/routing';
import { translate } from '@openclassrooms/translations';
import ApplyButton from '@openclassrooms/common-app/applications/components/ApplyButton';
import diplomaImageUrl from './images/diploma.svg';
import BaseBlock from './BaseBlock';
const ImageContent = styled(Box)(({
  theme: {
    breakpoints
  }
}) => ({
  display: 'none',
  '& > img': {
    width: 200
  },
  [breakpoints.up('md')]: {
    display: 'flex',
    minWidth: 280,
    alignItems: 'center',
    justifyContent: 'center'
  }
}));
const List = styled(Typography)(({
  theme: {
    spacing,
    typography
  }
}) => ({
  margin: spacing(1, 0, 2, 0),
  padding: spacing(0, 0, 0, 4),
  fontWeight: typography.fontWeightMedium,
  '& > li': {
    lineHeight: spacing(4)
  }
}));
const ActionsContainer = styled(Box)(({
  theme: {
    spacing
  }
}) => ({
  marginTop: spacing(2),
  display: 'flex',
  flexWrap: 'wrap',
  gap: spacing(2)
}));
const BigInfoBanner = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      display: "flex",
      gap: 4
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      flexGrow: 1
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Typography component="div" variant="h4">{translate("free_user.offer_diploma.intro.title")}</Typography>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <List component="ul"><li>{translate("free_user.offer_diploma.intro.uvp1")}</li><li>{translate("free_user.offer_diploma.intro.uvp2")}</li><li>{translate("free_user.offer_diploma.intro.uvp3")}</li><li>{translate("free_user.offer_diploma.intro.uvp4")}</li></List>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Typography component="div" variant="h4">{translate("free_user.offer_diploma.orientation.title")}</Typography>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ApplyButton variant="secondary">{translate("free_user.offer_diploma.button_orientation")}</ApplyButton>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Box sx={t1}>{t2}{t3}{t4}<ActionsContainer>{t5}<Button variant="tertiary" href={ROUTES.OFFERS.INDEX} rel="nofollow" data-event="Navigation|Redirection::Internal|Trainings comparison">{translate("global.compare_offers.action")}</Button></ActionsContainer></Box>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <BaseBlock><Box sx={t0}>{t6}<ImageContent><Image alt="" src={diplomaImageUrl} width={200} /></ImageContent></Box></BaseBlock>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};
export default BigInfoBanner;